import { useQuery } from 'react-query'

import type { AccessService } from 'features/settings/features/access/service/service'

const QUERY_KEY = 'hub-role'

export type UseHubRoleResult = {
  hubRole: string | undefined
  isLoading: boolean
}

/**
 * Fetch the caller's v2 RBAC role for the active hub from the canonical
 * `GET /client/hub/user` endpoint (PROD-3680). Used to gate role-restricted
 * UI — e.g. show the bulk add/share entry point only to hub owners. `hubRole`
 * is undefined while loading / when no hub is selected; consumers fail closed.
 */
export function useHubRole(
  projectId: string,
  service: AccessService,
): UseHubRoleResult {
  const { data: hubRole, isLoading } = useQuery(
    [QUERY_KEY, projectId],
    () => service.fetchHubRole(projectId),
    {
      enabled: Boolean(projectId),
      retry: false,
      refetchOnWindowFocus: false,
    },
  )

  return { hubRole, isLoading }
}
